/**
 * Open overlays that own the Escape key: a modal, a Radix popover or menu, an
 * open dialog. While one is on screen, a surface-level Escape (the companion
 * shell's, the AI desktop's document) leaves the key to it.
 */
export const ESCAPE_IGNORE_SELECTOR =
  '[data-slot="modal"], .modal-overlay, [data-radix-popper-content-wrapper], [role="menu"][data-state="open"], [role="dialog"][data-state="open"]';
